import './App.css';
import EnqueteView from './EnqueteView'
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';

function App() {

  return (
 
  <Router>
  <div>
  <Route path="/:id" component={EnqueteView} />
  </div>
  </Router>
  )
}

export default App;
